// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { Cmip7AssessmentFastTrackAftGetAftDiagnosticData, Cmip7AssessmentFastTrackAftGetAftDiagnosticErrors, Cmip7AssessmentFastTrackAftGetAftDiagnosticResponses, Cmip7AssessmentFastTrackAftListAftDiagnosticsData, Cmip7AssessmentFastTrackAftListAftDiagnosticsResponses, DatasetsExecutionsData, DatasetsExecutionsErrors, DatasetsExecutionsResponses, DatasetsGetData, DatasetsGetErrors, DatasetsGetResponses, DatasetsListData, DatasetsListErrors, DatasetsListResponses, DiagnosticsFacetsData, DiagnosticsFacetsResponses, DiagnosticsGetData, DiagnosticsGetErrors, DiagnosticsGetResponses, DiagnosticsListData, DiagnosticsListErrors, DiagnosticsListExecutionGroupsData, DiagnosticsListExecutionGroupsErrors, DiagnosticsListExecutionGroupsResponses, DiagnosticsListExecutionsData, DiagnosticsListExecutionsErrors, DiagnosticsListExecutionsResponses, DiagnosticsListMetricValuesData, DiagnosticsListMetricValuesErrors, DiagnosticsListMetricValuesResponses, DiagnosticsListResponses, ExecutionsExecutionArchiveData, ExecutionsExecutionArchiveErrors, ExecutionsExecutionArchiveResponses, ExecutionsExecutionData, ExecutionsExecutionDatasetsData, ExecutionsExecutionDatasetsErrors, ExecutionsExecutionDatasetsResponses, ExecutionsExecutionErrors, ExecutionsExecutionLogsData, ExecutionsExecutionLogsErrors, ExecutionsExecutionLogsResponses, ExecutionsExecutionResponses, ExecutionsGetData, ExecutionsGetErrors, ExecutionsGetExecutionStatisticsData, ExecutionsGetExecutionStatisticsResponses, ExecutionsGetResponses, ExecutionsListMetricValuesData, ExecutionsListMetricValuesErrors, ExecutionsListMetricValuesResponses, ExecutionsListRecentExecutionGroupsData, ExecutionsListRecentExecutionGroupsErrors, ExecutionsListRecentExecutionGroupsResponses, ExecutionsMetricBundleData, ExecutionsMetricBundleErrors, ExecutionsMetricBundleResponses, ExplorerGetCollectionData, ExplorerGetCollectionErrors, ExplorerGetCollectionResponses, ExplorerGetThemeData, ExplorerGetThemeErrors, ExplorerGetThemeResponses, ExplorerListCollectionsData, ExplorerListCollectionsResponses, ExplorerListThemesData, ExplorerListThemesResponses, ResultsGetResultData, ResultsGetResultErrors, ResultsGetResultResponses, UtilsAboutData, UtilsAboutResponses, UtilsHealthCheckData, UtilsHealthCheckResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * List Aft Diagnostics
 *
 * Get all AFT diagnostics.
 */
export const cmip7AssessmentFastTrackAftListAftDiagnostics = <ThrowOnError extends boolean = false>(options?: Options<Cmip7AssessmentFastTrackAftListAftDiagnosticsData, ThrowOnError>): RequestResult<Cmip7AssessmentFastTrackAftListAftDiagnosticsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<Cmip7AssessmentFastTrackAftListAftDiagnosticsResponses, unknown, ThrowOnError>({ url: '/api/v1/cmip7-aft-diagnostics/', ...options });

/**
 * Get Aft Diagnostic
 *
 * Get detailed AFT diagnostic by ID.
 */
export const cmip7AssessmentFastTrackAftGetAftDiagnostic = <ThrowOnError extends boolean = false>(options: Options<Cmip7AssessmentFastTrackAftGetAftDiagnosticData, ThrowOnError>): RequestResult<Cmip7AssessmentFastTrackAftGetAftDiagnosticResponses, Cmip7AssessmentFastTrackAftGetAftDiagnosticErrors, ThrowOnError> => (options.client ?? client).get<Cmip7AssessmentFastTrackAftGetAftDiagnosticResponses, Cmip7AssessmentFastTrackAftGetAftDiagnosticErrors, ThrowOnError>({ url: '/api/v1/cmip7-aft-diagnostics/{aft_id}', ...options });

/**
 * List
 *
 * Paginated list of currently ingested datasets
 *
 * Only the latest version of each dataset is returned.
 */
export const datasetsList = <ThrowOnError extends boolean = false>(options?: Options<DatasetsListData, ThrowOnError>): RequestResult<DatasetsListResponses, DatasetsListErrors, ThrowOnError> => (options?.client ?? client).get<DatasetsListResponses, DatasetsListErrors, ThrowOnError>({ url: '/api/v1/datasets/', ...options });

/**
 * Get
 *
 * Get a single dataset by slug
 *
 * When several versions share a slug, the latest is returned.
 */
export const datasetsGet = <ThrowOnError extends boolean = false>(options: Options<DatasetsGetData, ThrowOnError>): RequestResult<DatasetsGetResponses, DatasetsGetErrors, ThrowOnError> => (options.client ?? client).get<DatasetsGetResponses, DatasetsGetErrors, ThrowOnError>({ url: '/api/v1/datasets/{slug}', ...options });

/**
 * Executions
 *
 * List the currently registered diagnostics
 */
export const datasetsExecutions = <ThrowOnError extends boolean = false>(options: Options<DatasetsExecutionsData, ThrowOnError>): RequestResult<DatasetsExecutionsResponses, DatasetsExecutionsErrors, ThrowOnError> => (options.client ?? client).get<DatasetsExecutionsResponses, DatasetsExecutionsErrors, ThrowOnError>({ url: '/api/v1/datasets/{dataset_id}/executions', ...options });

/**
 * List
 *
 * List the currently registered diagnostics
 *
 * Pass `mip_era` to count only the execution groups that ran against that era.
 */
export const diagnosticsList = <ThrowOnError extends boolean = false>(options?: Options<DiagnosticsListData, ThrowOnError>): RequestResult<DiagnosticsListResponses, DiagnosticsListErrors, ThrowOnError> => (options?.client ?? client).get<DiagnosticsListResponses, DiagnosticsListErrors, ThrowOnError>({ url: '/api/v1/diagnostics/', ...options });

/**
 * Facets
 *
 * Query the unique dimensions and metrics for all diagnostics (both scalar and series)
 */
export const diagnosticsFacets = <ThrowOnError extends boolean = false>(options?: Options<DiagnosticsFacetsData, ThrowOnError>): RequestResult<DiagnosticsFacetsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DiagnosticsFacetsResponses, unknown, ThrowOnError>({ url: '/api/v1/diagnostics/facets', ...options });

/**
 * Get
 *
 * Fetch a result using the slug
 */
export const diagnosticsGet = <ThrowOnError extends boolean = false>(options: Options<DiagnosticsGetData, ThrowOnError>): RequestResult<DiagnosticsGetResponses, DiagnosticsGetErrors, ThrowOnError> => (options.client ?? client).get<DiagnosticsGetResponses, DiagnosticsGetErrors, ThrowOnError>({ url: '/api/v1/diagnostics/{provider_slug}/{diagnostic_slug}', ...options });

/**
 * List Execution Groups
 *
 * Fetch execution groups for a diagnostic.
 *
 * Pass `mip_era` to keep only the groups that ran against that era.
 */
export const diagnosticsListExecutionGroups = <ThrowOnError extends boolean = false>(options: Options<DiagnosticsListExecutionGroupsData, ThrowOnError>): RequestResult<DiagnosticsListExecutionGroupsResponses, DiagnosticsListExecutionGroupsErrors, ThrowOnError> => (options.client ?? client).get<DiagnosticsListExecutionGroupsResponses, DiagnosticsListExecutionGroupsErrors, ThrowOnError>({ url: '/api/v1/diagnostics/{provider_slug}/{diagnostic_slug}/execution_groups', ...options });

/**
 * List Executions
 *
 * Fetch executions for a specific diagnostic, with arbitrary filters on the dataset.
 *
 * e.g. `?source_id=MIROC6&experiment_id=ssp585`. Pass `mip_era` to restrict to one era.
 */
export const diagnosticsListExecutions = <ThrowOnError extends boolean = false>(options: Options<DiagnosticsListExecutionsData, ThrowOnError>): RequestResult<DiagnosticsListExecutionsResponses, DiagnosticsListExecutionsErrors, ThrowOnError> => (options.client ?? client).get<DiagnosticsListExecutionsResponses, DiagnosticsListExecutionsErrors, ThrowOnError>({ url: '/api/v1/diagnostics/{provider_slug}/{diagnostic_slug}/executions', ...options });

/**
 * List Metric Values
 *
 * Get all the diagnostic values for a given diagnostic (both scalar and series)
 *
 * - `value_type`: Type of metric values - 'scalar', 'series', or 'all' (required)
 * - `format`: Return format - 'json' (default) or 'csv'
 * - `offset`: Number of items to skip (default 0)
 * - `limit`: Maximum number of items to return (default 50, max 500)
 * - `mip_era`: Restrict to the executions of one era, so outlier detection and pagination
 * see only the values the caller is charting
 */
export const diagnosticsListMetricValues = <ThrowOnError extends boolean = false>(options: Options<DiagnosticsListMetricValuesData, ThrowOnError>): RequestResult<DiagnosticsListMetricValuesResponses, DiagnosticsListMetricValuesErrors, ThrowOnError> => (options.client ?? client).get<DiagnosticsListMetricValuesResponses, DiagnosticsListMetricValuesErrors, ThrowOnError>({ url: '/api/v1/diagnostics/{provider_slug}/{diagnostic_slug}/values', ...options });

/**
 * Get Execution Statistics
 *
 * Get execution statistics for the dashboard.
 *
 * Execution groups are counted at the promoted version of each diagnostic,
 * and classified by the outcome of their latest execution.
 */
export const executionsGetExecutionStatistics = <ThrowOnError extends boolean = false>(options?: Options<ExecutionsGetExecutionStatisticsData, ThrowOnError>): RequestResult<ExecutionsGetExecutionStatisticsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ExecutionsGetExecutionStatisticsResponses, unknown, ThrowOnError>({ url: '/api/v1/executions/statistics', ...options });

/**
 * List Recent Execution Groups
 *
 * List the most recent execution groups
 *
 * Only groups at the promoted version of their diagnostic are returned.
 *
 * Supports filtering by:
 * - diagnostic_name_contains (case-insensitive substring of the diagnostic slug)
 * - provider_name_contains (case-insensitive substring of the provider slug)
 * - dirty
 * - successful (filters by latest execution success)
 * - source_id (filters groups that include an execution whose datasets
 * include a CMIP6 or CMIP7 dataset with this source_id)
 * - mip_era (restricts the above to a single era, CMIP6 or CMIP7)
 */
export const executionsListRecentExecutionGroups = <ThrowOnError extends boolean = false>(options?: Options<ExecutionsListRecentExecutionGroupsData, ThrowOnError>): RequestResult<ExecutionsListRecentExecutionGroupsResponses, ExecutionsListRecentExecutionGroupsErrors, ThrowOnError> => (options?.client ?? client).get<ExecutionsListRecentExecutionGroupsResponses, ExecutionsListRecentExecutionGroupsErrors, ThrowOnError>({ url: '/api/v1/executions/', ...options });

/**
 * Get
 *
 * Inspect a specific execution
 */
export const executionsGet = <ThrowOnError extends boolean = false>(options: Options<ExecutionsGetData, ThrowOnError>): RequestResult<ExecutionsGetResponses, ExecutionsGetErrors, ThrowOnError> => (options.client ?? client).get<ExecutionsGetResponses, ExecutionsGetErrors, ThrowOnError>({ url: '/api/v1/executions/{group_id}', ...options });

/**
 * Execution
 *
 * Inspect a specific execution
 *
 * Gets the latest result if no execution_id is provided
 */
export const executionsExecution = <ThrowOnError extends boolean = false>(options: Options<ExecutionsExecutionData, ThrowOnError>): RequestResult<ExecutionsExecutionResponses, ExecutionsExecutionErrors, ThrowOnError> => (options.client ?? client).get<ExecutionsExecutionResponses, ExecutionsExecutionErrors, ThrowOnError>({ url: '/api/v1/executions/{group_id}/execution', ...options });

/**
 * Execution Datasets
 *
 * Query the datasets that were used for a specific execution
 */
export const executionsExecutionDatasets = <ThrowOnError extends boolean = false>(options: Options<ExecutionsExecutionDatasetsData, ThrowOnError>): RequestResult<ExecutionsExecutionDatasetsResponses, ExecutionsExecutionDatasetsErrors, ThrowOnError> => (options.client ?? client).get<ExecutionsExecutionDatasetsResponses, ExecutionsExecutionDatasetsErrors, ThrowOnError>({ url: '/api/v1/executions/{group_id}/datasets', ...options });

/**
 * Execution Logs
 *
 * Fetch the logs for an execution result
 */
export const executionsExecutionLogs = <ThrowOnError extends boolean = false>(options: Options<ExecutionsExecutionLogsData, ThrowOnError>): RequestResult<ExecutionsExecutionLogsResponses, ExecutionsExecutionLogsErrors, ThrowOnError> => (options.client ?? client).get<ExecutionsExecutionLogsResponses, ExecutionsExecutionLogsErrors, ThrowOnError>({ url: '/api/v1/executions/{group_id}/logs', ...options });

/**
 * Metric Bundle
 *
 * Fetch a result using the slug
 */
export const executionsMetricBundle = <ThrowOnError extends boolean = false>(options: Options<ExecutionsMetricBundleData, ThrowOnError>): RequestResult<ExecutionsMetricBundleResponses, ExecutionsMetricBundleErrors, ThrowOnError> => (options.client ?? client).get<ExecutionsMetricBundleResponses, ExecutionsMetricBundleErrors, ThrowOnError>({ url: '/api/v1/executions/{group_id}/metric_bundle', ...options });

/**
 * List Metric Values
 *
 * Fetch metric values for a specific execution (both scalar and series)
 *
 * - `value_type`: Type of metric values - 'scalar', 'series', or 'all' (required)
 * - `format`: Return format - 'json' (default) or 'csv'
 * - `offset`: Number of items to skip (default 0)
 * - `limit`: Maximum number of items to return (default 50, max 500)
 */
export const executionsListMetricValues = <ThrowOnError extends boolean = false>(options: Options<ExecutionsListMetricValuesData, ThrowOnError>): RequestResult<ExecutionsListMetricValuesResponses, ExecutionsListMetricValuesErrors, ThrowOnError> => (options.client ?? client).get<ExecutionsListMetricValuesResponses, ExecutionsListMetricValuesErrors, ThrowOnError>({ url: '/api/v1/executions/{group_id}/values', ...options });

/**
 * Execution Archive
 *
 * Stream a tar.gz archive of the execution results
 *
 * The archive is created on-the-fly and streamed directly to the client.
 */
export const executionsExecutionArchive = <ThrowOnError extends boolean = false>(options: Options<ExecutionsExecutionArchiveData, ThrowOnError>): RequestResult<ExecutionsExecutionArchiveResponses, ExecutionsExecutionArchiveErrors, ThrowOnError> => (options.client ?? client).get<ExecutionsExecutionArchiveResponses, ExecutionsExecutionArchiveErrors, ThrowOnError>({ url: '/api/v1/executions/{group_id}/archive', ...options });

/**
 * List Collections
 */
export const explorerListCollections = <ThrowOnError extends boolean = false>(options?: Options<ExplorerListCollectionsData, ThrowOnError>): RequestResult<ExplorerListCollectionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ExplorerListCollectionsResponses, unknown, ThrowOnError>({ url: '/api/v1/explorer/collections/', ...options });

/**
 * Get Collection
 */
export const explorerGetCollection = <ThrowOnError extends boolean = false>(options: Options<ExplorerGetCollectionData, ThrowOnError>): RequestResult<ExplorerGetCollectionResponses, ExplorerGetCollectionErrors, ThrowOnError> => (options.client ?? client).get<ExplorerGetCollectionResponses, ExplorerGetCollectionErrors, ThrowOnError>({ url: '/api/v1/explorer/collections/{collection_id}', ...options });

/**
 * List Themes
 */
export const explorerListThemes = <ThrowOnError extends boolean = false>(options?: Options<ExplorerListThemesData, ThrowOnError>): RequestResult<ExplorerListThemesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ExplorerListThemesResponses, unknown, ThrowOnError>({ url: '/api/v1/explorer/themes/', ...options });

/**
 * Get Theme
 */
export const explorerGetTheme = <ThrowOnError extends boolean = false>(options: Options<ExplorerGetThemeData, ThrowOnError>): RequestResult<ExplorerGetThemeResponses, ExplorerGetThemeErrors, ThrowOnError> => (options.client ?? client).get<ExplorerGetThemeResponses, ExplorerGetThemeErrors, ThrowOnError>({ url: '/api/v1/explorer/themes/{theme_slug}', ...options });

/**
 * Get Result
 *
 * Fetch a result
 */
export const resultsGetResult = <ThrowOnError extends boolean = false>(options: Options<ResultsGetResultData, ThrowOnError>): RequestResult<ResultsGetResultResponses, ResultsGetResultErrors, ThrowOnError> => (options.client ?? client).get<ResultsGetResultResponses, ResultsGetResultErrors, ThrowOnError>({ url: '/api/v1/results/{result_id}', ...options });

/**
 * Health Check
 */
export const utilsHealthCheck = <ThrowOnError extends boolean = false>(options?: Options<UtilsHealthCheckData, ThrowOnError>): RequestResult<UtilsHealthCheckResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UtilsHealthCheckResponses, unknown, ThrowOnError>({ url: '/api/v1/utils/health-check/', ...options });

/**
 * About
 *
 * Version and freshness information about the deployment serving this API
 */
export const utilsAbout = <ThrowOnError extends boolean = false>(options?: Options<UtilsAboutData, ThrowOnError>): RequestResult<UtilsAboutResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UtilsAboutResponses, unknown, ThrowOnError>({ url: '/api/v1/utils/about', ...options });
